import { Route } from 'react-router-dom'
import { MsgHelpers } from 'ui'
import { useLocation } from 'hooks'
import { Container } from './styles'
import React, { useCallback } from 'react'


const RoutePlay = ({ exact, path, component: Component, ...rest }) => {
  const { pathname } = useLocation()

  const Wrapper = useCallback(() => {
    const showHelpers = pathname === '/series'

    return (
      <Container>
        {showHelpers && <MsgHelpers />}
        <Component />
      </Container>
    )
  }, [pathname])

  return <Route name={path} exact={exact} path={path} component={Wrapper} {...rest} />
}

export default React.memo(RoutePlay)